import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
const Footer = styled.footer `
  display: flex;
  background-color: rgba(0, 0, 0, 0);
  justify-content: center;
  width: 100%;
  background-color: #01294E;
  color: #fff;

  @media (max-width: 900px) {
    display: none;
  }
`;
const List = styled.ul `
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  gap: 20px;
`;
const StyledLink = styled(Link) `
  color: #fff;
  text-decoration: underline;

  &:visited {
    color: #000000;
  }

  &:hover {
    color: #363535;
  }
`;
const LegalFooter = () => {
    var _a;
    const { t } = useTranslation('common');
    return (React.createElement(Footer, null,
        React.createElement(List, null,
            React.createElement("li", null, t('signin.copyright', { year: new Date().getFullYear() })),
            React.createElement("li", null,
                t('signin.version'),
                " ", (_a = process.env.EXFLUENCY_VERSION) !== null && _a !== void 0 ? _a : 'devel'),
            React.createElement("li", null,
                React.createElement(StyledLink, { target: "_blank", to: "/terms-of-service" }, t('termsAndConditions.termsOfService'))),
            React.createElement("li", null,
                React.createElement(StyledLink, { target: "_blank", to: "/privacy-notice" }, t('termsAndConditions.privacyNotice'))))));
};
export default LegalFooter;
